import { render, staticRenderFns } from "./UnitDialog.vue?vue&type=template&id=44dd0ac9"
import script from "./UnitDialog.vue?vue&type=script&lang=js"
export * from "./UnitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports